// AppConfirmBox.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Autocomplete,
} from "@mui/material";

export default function AppConfirmBox({
  open,
  title = "Are you sure?",
  showRemark = false,
  remark,
  setRemark,
  showAmount = false,
  amount,
  setAmount,
  maxAmount = null,
  showSubTypes = false,
  subTypes,
  setSubTypes,
  subTypeOptions = [],
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  onClose,
  onConfirm,
}) {
  const amountExceeds =
    maxAmount !== null && Number(amount) > Number(maxAmount);

  const handleConfirmClick = () => {
    onConfirm?.(remark, amount, subTypes);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "rounded-lg p-3 sm:p-6 w-[90%] sm:w-[420px] shadow-xl",
      }}
    >
      <DialogTitle className="text-center font-semibold text-lg text-gray-800">
        {title}
      </DialogTitle>

      {(showRemark || showAmount || showSubTypes) && (
        <DialogContent className="mt-2">
          <Box className="mt-1 min-w-[300px] flex flex-col gap-3">
            {showSubTypes && (
              <Autocomplete
                multiple
                size="small"
                options={subTypeOptions}
                value={subTypes || []}
                onChange={(_, newValue) => setSubTypes(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Sub Types" placeholder="Select subtype" />
                )}
              />
            )}
            {showAmount && (
              <TextField
                label="Amount"
                size="small"
                fullWidth
                type="number"
                value={amount}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || Number(val) >= 0) setAmount(val);
                }}
                inputProps={{ min: 0 }}
                error={amountExceeds}
                helperText={
                  amountExceeds ? `Amount cannot exceed ${maxAmount}` : ""
                }
              />
            )}
            {showRemark && (
              <TextField
                label="Remark"
                size="small"
                fullWidth
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            )}
          </Box>
        </DialogContent>
      )}

      <DialogActions className="flex justify-center gap-4 pb-4">
        <Button
          variant="outlined"
          onClick={onClose}
          className="!border-gray-400 !text-gray-700 w-28 h-10"
        >
          {cancelText}
        </Button>

        <Button
          variant="contained"
          color={confirmColor}
          onClick={handleConfirmClick}
          disabled={
            (showRemark && !remark) ||
            (showAmount && !amount) ||
            (showSubTypes && (!subTypes || subTypes.length === 0)) ||
            amountExceeds
          }
          className="w-28 h-10"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}